import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './TableSkeleton.scss';

interface TableSkeletonProps {
  rowCount?: number;
}

const DEFAULT_ROW_COUNT: number = 8;

const TableSkeleton = ({ rowCount = DEFAULT_ROW_COUNT }: TableSkeletonProps) => {
  return (
    <div className="table-skeleton">
      <Skeleton
        variant="rect"
        height="2.5rem"
        className="table-skeleton-header"
      />
      {Array.from({ length: rowCount }, (_: unknown, rowIndex: number) => (
        <Skeleton
          key={`table-skeleton-row-${rowIndex}`}
          variant="rect"
          height="2rem"
        />
      ))}
    </div>
  );
};

export default TableSkeleton;